// Every first-visit tour in the app, in one place: its id (which scopes the per-user "seen"
// flag), the order it runs in when several are eligible at once, and the release date it is
// tied to. Tours are queued app-wide, so the ordering only makes sense declared together.
//
// A new id must also be added to `AUTO_OPEN_TOUR_IDS` in `e2e/global-setup.ts`, which seeds
// tours as already seen — otherwise its spotlight overlay covers the UI the specs drive.

export const TOUR_IDS = {
  documentsNavSection: 'documents-nav-section-v1',
  notificationBell: 'notification-bell-v1',
  orderEdocumentsTab: 'order-edocuments-tab-v1',
  contentListViews: 'content-list-views-v1',
  listOrdering: 'list-ordering-v1',
  diagrammingListViews: 'diagramming-list-views-v1',
} as const;

// Lower runs first. The sidebar tour explains where the section moved, so it precedes the
// order-page tour that lives inside it.
export const TOUR_PRIORITY = {
  documentsNavSection: 10,
  notificationBell: 20,
  orderEdocumentsTab: 30,
  contentListViews: 40,
  listOrdering: 45,
  diagrammingListViews: 50,
} as const;

export const DEFAULT_TOUR_PRIORITY = 100;

// Production release date of the Documents section and the order eDocuments tab (SPAZ2-3343).
// Only users created before this date saw the app without them, so only they get the tour;
// an account created on/after it is skipped.
export const DOCUMENTS_RELEASE_DATE = new Date('2026-08-18T00:00:00Z');

// Production release date of the table/cards content lists and their card ordering
// (SPAZ2-3419). Same rule: an account created on/after it never saw the plain tables these
// views replaced, so it is never shown either list-views tour.
export const LIST_VIEWS_RELEASE_DATE = new Date('2026-09-17T00:00:00Z');
